import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const getDate = dayjs;

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
